export default __webpack_public_path__ + "e084f1c8b648d7d45a50b0dae900c8b6.ttf";